<template>
  <div class="newsList">
    <ul>
      <li class="list-head">最新资讯</li>
      <li class="list-content" v-for="(item, key) in newsList" :key="key" @click="newClick(item.formUrl)">
        <div class="img-box">
          <img :src="item.url" alt="">
        </div>
        <div>
          <div class="title">{{item.title}}</div>
          <div class="content">{{item.content}}</div>
          <div class="time">{{item.time}}</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'newsList',
  props: ['newsList'],
  methods: {
    newClick (url) {
      window.open(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.newsList{
  width: 100%;
  .list-head{
    font-size: 18px;
    border-left: 4px solid #ce443a;
    padding-left: 15px;
    line-height: 20px;
  }
  .list-content{
    width: 100%;
    display: flex;
    padding: 20px 0px;
    border-bottom: 1px solid #eee;
    cursor: pointer;
    .img-box{
      width: 180px;
      height: 110px;
      margin-right: 20px;
      flex-shrink: 0;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .title{
      font-size: 20px;
      margin-bottom: 10px;
    }
    .content{
      color: #999999;
      overflow: hidden;
      min-height: 50px;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      margin-bottom: 14px;
    }
    .time{
      width: 100%;
      text-align: right;
      color: #999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newsList.vue